document.addEventListener('DOMContentLoaded', () => {
    function setCookie(key, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${key}=${value};path=/;expires=${expires.toUTCString()}`;
    }

    function showCookieWarn() {
        const cookieWarnEl = document.getElementById('cookie-warn');
        const cookieWarnButtonEl = cookieWarnEl.querySelector(
            '.js-cookie-warn-agree'
        );
        if (!cookieWarnEl) return;

        cookieWarnEl.style.display = 'flex';
        cookieWarnEl.style.opacity = 1;

        cookieWarnButtonEl.addEventListener('click', (e) => {
            e.preventDefault();
            setCookie('cookie-confirmed', '1', 2000);
            cookieWarnEl.style.display = 'none';
            cookieWarnEl.style.opacity = 0;
        });
    }

    function getCookie(key) {
        const keyValue = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`);
        return keyValue ? keyValue[2] : null;
    }

    if (!getCookie('cookie-confirmed')) {
        showCookieWarn();
    }
});
